import { __rest } from "tslib";
import clsx from 'clsx';
import React from 'react';
import { defaultInitials } from './utils';
const Avatar = React.forwardRef((_a, ref) => {
    var { className, src, size, rounded, status, statusClassName, name } = _a, props = __rest(_a, ["className", "src", "size", "rounded", "status", "statusClassName", "name"]);
    const value = defaultInitials(name || 'U', { maxInitials: 2 });
    return (React.createElement("div", Object.assign({ ref: ref }, props, { className: clsx('cmp-avatar', className, size ? `cmp-avatar-${size}` : false, rounded ? 'cmp-avatar-rounded' : false) }, props),
        src ? React.createElement("img", { src: src, className: 'cmp-avatar-img' }) : value,
        status && (React.createElement("span", { className: clsx('cmp-avatar-status', statusClassName) }))));
});
Avatar.displayName = 'Avatar';
export { Avatar };
//# sourceMappingURL=Avatar.js.map